module.exports = __webpack_public_path__ + "static/media/sunyiwen.92b5c9bf.jpg";